/* Politika sayfaları: yinelenen başlığı gizler, belge başlıklarından "Bu sayfada" listesini kurar. */
(() => {
  const doc = document.querySelector('[data-pg-legal-doc]');
  if (!doc) return;

  const norm = (s) => s.toLocaleLowerCase('tr').replace(/[^\p{L}\p{N}]+/gu, ' ').trim();
  const title = norm(doc.dataset.title || '');

  // Metnin başında sayfa başlığını tekrar eden satır
  const first = doc.querySelector('h2, h3, h4');
  if (first && !first.previousElementSibling && norm(first.textContent).includes(title)) first.remove();

  // Metnin kendi "İçindekiler" listesi: yerine "Bu sayfada" listesi geçiyor
  doc.querySelectorAll('h2, h3, h4').forEach((h) => {
    if (norm(h.textContent) !== 'içindekiler') return;
    const list = h.nextElementSibling;
    if (list && /^(UL|OL)$/.test(list.tagName)) list.remove();
    h.remove();
  });

  // Üst başlık düzeyi: en az 3 başlığı olan ilk düzey
  const level = ['h2', 'h3', 'h4'].find((t) => doc.querySelectorAll(t).length >= 3);
  if (!level) return;
  const heads = [...doc.querySelectorAll(level)].filter((h) => h.textContent.trim());
  if (heads.length < 3) return;

  const cut = (s) => s.replace(/^[^\p{L}\p{N}]+/u, '').replace(/\s+/g, ' ').trim();
  const items = heads.map((h, i) => {
    h.id = h.id || `pg-legal-${i + 1}`;
    h.setAttribute('data-pg-legal-head', '');
    return `<li><a href="#${h.id}">${cut(h.textContent).replace(/[<>&]/g, '')}</a></li>`;
  }).join('');
  document.querySelectorAll('[data-pg-legal-toc]').forEach((el) => {
    el.innerHTML = `<ul class="pg-legal__toc">${items}</ul>`;
  });
  document.querySelectorAll('[data-pg-legal-toc-box]').forEach((el) => { el.hidden = false; });

  // Telefonda seçimden sonra listeyi kapat
  document.querySelectorAll('details[data-pg-legal-toc-box] a').forEach((a) => {
    a.addEventListener('click', () => { a.closest('details').open = false; });
  });

  // Okunan bölümü işaretle
  const links = new Map();
  document.querySelectorAll('.pg-legal__box--desktop .pg-legal__toc a').forEach((a) => {
    links.set(a.getAttribute('href').slice(1), a);
  });
  if (!links.size) return;
  let current = null;
  let tick = 0;
  const mark = () => {
    tick = 0;
    let head = null;
    for (const h of heads) {
      if (h.getBoundingClientRect().top > 220) break;
      head = h;
    }
    const link = head ? links.get(head.id) : null;
    if (link === current) return;
    current?.classList.remove('is-current');
    link?.classList.add('is-current');
    current = link;
  };
  addEventListener('scroll', () => { tick ||= requestAnimationFrame(mark); }, { passive: true });
  mark();
})();
